"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _usStates = require("@hyperobjekt/us-states");

var _styles = require("@material-ui/styles");

var _GeoJsonLayer = _interopRequireDefault(require("../GeoJsonLayer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * URL to state level GeoJSON
 */


var geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
/**
 * offsets for states
 */

var stateOffsets = {
  VT: [50, -8],
  NH: [34, 2],
  MA: [30, -1],
  RI: [28, 2],
  CT: [35, 10],
  NJ: [34, 1],
  DE: [33, 0],
  MD: [47, 10],
  DC: [49, 21]
};
/**
 * associated state level metadata
 */

var stateMetadata = (0, _usStates.getStatesArray)().map(function (s) {
  return {
    id: s.id,
    val: s.abbr,
    offset: stateOffsets[s.abbr]
  };
});
/**
 * thunk that takes the geography, then returns a selector function
 * to match the related metadata
 */

var stateMetadataSelector = function stateMetadataSelector(geo) {
  return function (data) {
    return data.id === geo.id;
  };
};
/**
 * selector function to get the state label
 */


var stateLabelSelector = function stateLabelSelector(d) {
  return d && d.val;
};

var styles = {
  root: {},
  shape: {},
  hovered: {},
  selected: {},
  label: {},
  marker: {},
  annotation: {},
  text: {}
};
/**
 * Renders US state level shapes
 */

var StateLayer = function StateLayer(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      shapeProps = _ref.shapeProps,
      labelProps = _ref.labelProps,
      props = _objectWithoutProperties(_ref, ["classes", "className", "shapeProps", "labelProps"]);

  return /*#__PURE__*/_react["default"].createElement(_GeoJsonLayer["default"], _extends({
    className: (0, _clsx["default"])(classes.root, className),
    source: geoUrl,
    metadata: stateMetadata,
    metaDataSelector: stateMetadataSelector,
    labelSelector: stateLabelSelector,
    shapeProps: _objectSpread({
      classes: {
        shape: classes.shape,
        hovered: classes.hovered,
        selected: classes.selected
      }
    }, shapeProps),
    labelProps: _objectSpread({
      classes: {
        label: classes.label,
        marker: classes.marker,
        annotation: classes.annotation,
        text: classes.text
      }
    }, labelProps)
  }, props));
};

StateLayer.propTypes = {
  labelProps: {},
  shapeProps: {}
};
StateLayer.propTypes = _GeoJsonLayer["default"].propTypes;
/** add the display name */

var exportComponent = (0, _styles.withStyles)(styles, {
  name: "HypStateLayer"
})(StateLayer);
exportComponent.displayName = "StateLayer";
var _default = exportComponent;
exports["default"] = _default;